import BlogIcon from "../assets/icons/BlogIcon";
import DomainIcon from "../assets/icons/DomainIcon";
import FacebookIcon from "../assets/icons/FacebookIcon";
import GithubIcon from "../assets/icons/GithubIcon";
import InstagramIcon from "../assets/icons/InstagramIcon";
import LinkedInIcon from "../assets/icons/LinkedInIcon";
import PinterestIcon from "../assets/icons/PinterestIcon";
import PortfolioIcon from "../assets/icons/PortfolioIcon";
import SnapchatIcon from "../assets/icons/SnapchatIcon";
import TelegramIcon from "../assets/icons/TelegramIcon";
import TiktokIcon from "../assets/icons/TiktokIcon";
import TwitterIcon from "../assets/icons/TwitterIcon";
import WebsiteIcon from "../assets/icons/WebsiteIcon";
import WhatsappIcon from "../assets/icons/WhatsappIcon";
import YoutubeIcon from "../assets/icons/YoutubeIcon";

export const getSocialIcon = (fieldName: string): React.ReactNode => {
    if (!fieldName || typeof fieldName !== 'string') return null;

    // Normalize: remove "Link - " prefix (case-insensitive) and trim
    const platform = fieldName
        .replace(/^Link\s*-\s*/i, '') // Removes "Link - " in any casing/spaces
        .trim();

    // Platform keywords to icon mapping (all lowercase keys)
    const iconMap: Record<string, React.ReactNode> = {
        youtube: <YoutubeIcon />,
        linkedin: <LinkedInIcon />,
        instagram: <InstagramIcon />,
        facebook: <FacebookIcon />,
        twitter: <TwitterIcon />,
        tiktok: <TiktokIcon />,
        pinterest: <PinterestIcon />,
        snapchat: <SnapchatIcon />,
        whatsapp: <WhatsappIcon />,
        telegram: <TelegramIcon />,
        github: <GithubIcon />,
        portfolio: <PortfolioIcon />,
        blog: <BlogIcon />,
        domain: <DomainIcon />,
        other: <WebsiteIcon />,
        website: <WebsiteIcon />,
    };

    const normalizedPlatform = platform.toLowerCase();

    // 1. Agar exact match mila — icon return karo
    if (iconMap[normalizedPlatform]) {
        return iconMap[normalizedPlatform];
    }


    // 3. Agar field "Link -" format mein bhi nahi tha → koi icon nahi
    return null;
};